<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M21 3.01001H3C1.9 3.01001 1 3.91001 1 5.01001V9.00001H3V4.99001H21V19.02H3V15H1V19.01C1 20.11 1.9 20.99 3 20.99H21C22.1 20.99 23 20.11 23 19.01V5.01001C23 3.90001 22.1 3.01001 21 3.01001ZM11 16L15 12L11 8.00001V11H1V13H11V16ZM21 3.01001H3C1.9 3.01001 1 3.91001 1 5.01001V9.00001H3V4.99001H21V19.02H3V15H1V19.01C1 20.11 1.9 20.99 3 20.99H21C22.1 20.99 23 20.11 23 19.01V5.01001C23 3.90001 22.1 3.01001 21 3.01001ZM11 16L15 12L11 8.00001V11H1V13H11V16Z"
      fill="url(#paint0_linear_5364_5596)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_5364_5596"
        x1="1"
        y1="3.01001"
        x2="18.7041"
        y2="24.525"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.456596" stop-color="#DF252A" />
        <stop offset="1" stop-color="#A20004" />
      </linearGradient>
    </defs>
  </svg>
</template>
